import { useMemo, useState } from 'react'
import { ScanLine } from 'lucide-react'
import { resolveProductByCode } from '../../api/inventory'
import BarcodeScanner from '../../components/BarcodeScanner'
import { itemLabel, qty } from './inventoryShared'
import { CreateOption } from '../../components/CreateOption'

// Choose a stock item from a list, by typing or scanning its barcode/SKU
// (a handheld scanner types and presses Enter), or with the camera.
// Renders the top of a .ci-form-meta-card.
export default function ItemPicker({ items, value, onChange, label = 'Product' }) {
  const [code, setCode] = useState('')
  const [scanning, setScanning] = useState(false)
  const [error, setError] = useState('')
  const sorted = useMemo(() => [...items].sort((a, b) => String(a.name || a.sku).localeCompare(String(b.name || b.sku))), [items])

  const pick = async (raw) => {
    const c = String(raw || '').trim()
    if (!c) return
    setError('')
    const local = items.find((r) => [r.sku, r.barcode].some((v) => String(v || '').toLowerCase() === c.toLowerCase()))
    if (local) { onChange(String(local.product_id)); setCode(''); return }
    try {
      const p = await resolveProductByCode(c)
      if (p?.product_id) { onChange(String(p.product_id)); setCode(''); return }
    } catch { /* fall through */ }
    setError(`No product has the code ${c}.`)
  }

  return (
    <>
      <div className="ci-form-meta-top one">
        <label className="ci-form-field">
          <span>{label}</span>
          <select value={value} onChange={(e) => onChange(e.target.value)}>
            <option value="">Choose a product…</option>
            <CreateOption kind="product" />
            {sorted.map((p) => <option key={p.product_id} value={p.product_id}>{itemLabel(p)} · {qty(p.qty_on_hand)} on hand</option>)}
          </select>
        </label>
      </div>
      <form className="scan-row" onSubmit={(e) => { e.preventDefault(); pick(code) }}>
        <ScanLine size={16} aria-hidden="true" />
        <input value={code} onChange={(e) => { setCode(e.target.value); setError('') }} placeholder="Or scan / type a barcode or SKU, then press Enter" aria-label="Product code" />
        <button type="button" className="ci-btn ci-btn-ghost ci-btn-sm" onClick={() => setScanning(true)}>Camera</button>
      </form>
      {error && <p className="scan-error" role="alert">{error}</p>}
      <BarcodeScanner open={scanning} onClose={() => setScanning(false)} onScan={(c) => { setScanning(false); pick(c) }} />
    </>
  )
}
